@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.accounts.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.accounts.generated.resources/"

internal val Res.string.feature_accounts_popular_banks: StringResource by lazy {
      StringResource("string:feature_accounts_popular_banks", "feature_accounts_popular_banks", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7155, 58),
      ))
    }

internal val Res.string.feature_accounts_regular_charges_will_apply: StringResource by lazy {
      StringResource("string:feature_accounts_regular_charges_will_apply", "feature_accounts_regular_charges_will_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7214, 87),
      ))
    }

internal val Res.string.feature_accounts_saving_button_save: StringResource by lazy {
      StringResource("string:feature_accounts_saving_button_save", "feature_accounts_saving_button_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7302, 51),
      ))
    }

internal val Res.string.feature_accounts_saving_button_update: StringResource by lazy {
      StringResource("string:feature_accounts_saving_button_update", "feature_accounts_saving_button_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7354, 53),
      ))
    }

internal val Res.string.feature_accounts_saving_title_create: StringResource by lazy {
      StringResource("string:feature_accounts_saving_title_create", "feature_accounts_saving_title_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7408, 72),
      ))
    }

internal val Res.string.feature_accounts_saving_title_update: StringResource by lazy {
      StringResource("string:feature_accounts_saving_title_update", "feature_accounts_saving_title_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7481, 72),
      ))
    }

internal val Res.string.feature_accounts_savings_account: StringResource by lazy {
      StringResource("string:feature_accounts_savings_account", "feature_accounts_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7554, 60),
      ))
    }

internal val Res.string.feature_accounts_search: StringResource by lazy {
      StringResource("string:feature_accounts_search", "feature_accounts_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7615, 39),
      ))
    }

internal val Res.string.feature_accounts_setup_upi: StringResource by lazy {
      StringResource("string:feature_accounts_setup_upi", "feature_accounts_setup_upi", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7655, 46),
      ))
    }

internal val Res.string.feature_accounts_status_active: StringResource by lazy {
      StringResource("string:feature_accounts_status_active", "feature_accounts_status_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7702, 46),
      ))
    }

internal val Res.string.feature_accounts_status_approved: StringResource by lazy {
      StringResource("string:feature_accounts_status_approved", "feature_accounts_status_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7749, 52),
      ))
    }

internal val Res.string.feature_accounts_status_closed: StringResource by lazy {
      StringResource("string:feature_accounts_status_closed", "feature_accounts_status_closed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7802, 46),
      ))
    }

internal val Res.string.feature_accounts_status_matured: StringResource by lazy {
      StringResource("string:feature_accounts_status_matured", "feature_accounts_status_matured", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7849, 51),
      ))
    }

internal val Res.string.feature_accounts_status_pending_approval: StringResource by lazy {
      StringResource("string:feature_accounts_status_pending_approval", "feature_accounts_status_pending_approval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7901, 72),
      ))
    }

internal val Res.string.feature_accounts_status_prematurely_closed: StringResource by lazy {
      StringResource("string:feature_accounts_status_prematurely_closed", "feature_accounts_status_prematurely_closed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7974, 74),
      ))
    }

internal val Res.string.feature_accounts_status_rejected: StringResource by lazy {
      StringResource("string:feature_accounts_status_rejected", "feature_accounts_status_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8049, 52),
      ))
    }

internal val Res.string.feature_accounts_status_transfer_in_progress: StringResource by lazy {
      StringResource("string:feature_accounts_status_transfer_in_progress", "feature_accounts_status_transfer_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8102, 80),
      ))
    }

internal val Res.string.feature_accounts_status_transfer_on_hold: StringResource by lazy {
      StringResource("string:feature_accounts_status_transfer_on_hold", "feature_accounts_status_transfer_on_hold", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8183, 72),
      ))
    }

internal val Res.string.feature_accounts_status_withdrawn: StringResource by lazy {
      StringResource("string:feature_accounts_status_withdrawn", "feature_accounts_status_withdrawn", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8256, 53),
      ))
    }

internal val Res.string.feature_accounts_type: StringResource by lazy {
      StringResource("string:feature_accounts_type", "feature_accounts_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8310, 37),
      ))
    }

internal val Res.string.feature_accounts_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_accounts_unexpected_error_subtitle", "feature_accounts_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8348, 114),
      ))
    }

internal val Res.string.feature_accounts_update_savings_account: StringResource by lazy {
      StringResource("string:feature_accounts_update_savings_account", "feature_accounts_update_savings_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8463, 79),
      ))
    }

internal val Res.string.feature_accounts_verify_mobile_number: StringResource by lazy {
      StringResource("string:feature_accounts_verify_mobile_number", "feature_accounts_verify_mobile_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8543, 73),
      ))
    }

internal val Res.string.scan_qr_code: StringResource by lazy {
      StringResource("string:scan_qr_code", "scan_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8617, 36),
      ))
    }

internal val Res.string.skip_the_form: StringResource by lazy {
      StringResource("string:skip_the_form", "skip_the_form", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8654, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_accounts_popular_banks", Res.string.feature_accounts_popular_banks)
  map.put("feature_accounts_regular_charges_will_apply", Res.string.feature_accounts_regular_charges_will_apply)
  map.put("feature_accounts_saving_button_save", Res.string.feature_accounts_saving_button_save)
  map.put("feature_accounts_saving_button_update", Res.string.feature_accounts_saving_button_update)
  map.put("feature_accounts_saving_title_create", Res.string.feature_accounts_saving_title_create)
  map.put("feature_accounts_saving_title_update", Res.string.feature_accounts_saving_title_update)
  map.put("feature_accounts_savings_account", Res.string.feature_accounts_savings_account)
  map.put("feature_accounts_search", Res.string.feature_accounts_search)
  map.put("feature_accounts_setup_upi", Res.string.feature_accounts_setup_upi)
  map.put("feature_accounts_status_active", Res.string.feature_accounts_status_active)
  map.put("feature_accounts_status_approved", Res.string.feature_accounts_status_approved)
  map.put("feature_accounts_status_closed", Res.string.feature_accounts_status_closed)
  map.put("feature_accounts_status_matured", Res.string.feature_accounts_status_matured)
  map.put("feature_accounts_status_pending_approval", Res.string.feature_accounts_status_pending_approval)
  map.put("feature_accounts_status_prematurely_closed", Res.string.feature_accounts_status_prematurely_closed)
  map.put("feature_accounts_status_rejected", Res.string.feature_accounts_status_rejected)
  map.put("feature_accounts_status_transfer_in_progress", Res.string.feature_accounts_status_transfer_in_progress)
  map.put("feature_accounts_status_transfer_on_hold", Res.string.feature_accounts_status_transfer_on_hold)
  map.put("feature_accounts_status_withdrawn", Res.string.feature_accounts_status_withdrawn)
  map.put("feature_accounts_type", Res.string.feature_accounts_type)
  map.put("feature_accounts_unexpected_error_subtitle", Res.string.feature_accounts_unexpected_error_subtitle)
  map.put("feature_accounts_update_savings_account", Res.string.feature_accounts_update_savings_account)
  map.put("feature_accounts_verify_mobile_number", Res.string.feature_accounts_verify_mobile_number)
  map.put("scan_qr_code", Res.string.scan_qr_code)
  map.put("skip_the_form", Res.string.skip_the_form)
}
